@if (subcategories().length) {
    <section>
        <button class="text-title-small cursor-pointer px-2 text-left" (click)="resetSelectedSubcategoryId()">
            {{ "subcategory_sidebar.subcategories" | transloco }}
        </button>
        <div class="mt-4 flex flex-col gap-3">
            @for (subcategory of subcategories(); track subcategory.id) {
                @let isSelectedClass =
                    selectedSubcategoryId() === subcategory.id ? "text-white bg-primary rounded-lg" : "";
                <button
                    class="text-body-small cursor-pointer px-2 py-1 text-left"
                    [class]="isSelectedClass"
                    (click)="getSuppliersBySubcategory(subcategory.id)"
                >
                    {{ subcategory.translations_refs | getTranslation: "title" }}
                </button>
            }
        </div>
    </section>
}
